import React, { useState, useEffect, useContext } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import BackButton from "./BackButton";
import NextButton from "./NextButton";
import SkipButton from "./SkipButton";
import getNextPage from "./getNextPage";
import { RouterContext } from "./Onboarding";

export default function Services({
  pageLocator,
  searchEnabled,
  displayEnabled,
  socialEnabled,
  videoEnabled,
  setSearchEnabled,
  setDisplayEnabled,
  setSocialEnabled,
  setVideoEnabled,
  seo,
  setSeo,
  submitForm,
  onboarding_progress,
  client_account,
}) {
  const route = useContext(RouterContext);

  const nextPage = getNextPage(onboarding_progress);

  useEffect(() => {
    window.localStorage.setItem("routerHistory", JSON.stringify([...route.get]));
  }, [route.get]);
  let seoA = require("images/onboarding/seochart-active.png");
  seoA = <img className="py-4" src={`/datapulse${seoA}`} />;
  let seoI = require("images/onboarding/seochart-inactive.png");
  seoI = <img className="py-4" src={`/datapulse${seoI}`} />;
  let ppcA = require("images/onboarding/ppcchart-active.png");
  ppcA = <img className="py-4" src={`/datapulse${ppcA}`} />;
  let ppcI = require("images/onboarding/ppcchart-inactive.png");
  ppcI = <img className="py-4" src={`/datapulse${ppcI}`} />;
  let searchI = require("images/onboarding/magnify-inactive.png");
  searchI = <img className="py-3" src={`/datapulse${searchI}`} />;
  let searchA = require("images/onboarding/magnify-active.png");
  searchA = <img className="py-3" src={`/datapulse${searchA}`} />;
  let displayA = require("images/onboarding/display-active.png");
  displayA = <img className="py-3" src={`/datapulse${displayA}`} />;
  let displayI = require("images/onboarding/display-inactive.png");
  displayI = <img className="py-3" src={`/datapulse${displayI}`} />;
  let socialI = require("images/onboarding/social-inactive.png");
  socialI = <img className="py-3" src={`/datapulse${socialI}`} />;
  let socialA = require("images/onboarding/social-active.png");
  socialA = <img className="py-3" src={`/datapulse${socialA}`} />;
  let videoI = require("images/onboarding/video-inactive.png");
  videoI = <img className="py-3" src={`/datapulse${videoI}`} />;
  let videoA = require("images/onboarding/video-active.png");
  videoA = <img className="py-3" src={`/datapulse${videoA}`} />;

  pageLocator();

  const [validated, setValidated] = useState(false);

  useEffect(() => {
    const form = document.getElementById("onboarding-form");
    if (seo) {
      if (!ppc) {
        setValidated(true);
      }
      if (ppc) {
        if (searchEnabled || displayEnabled || socialEnabled || videoEnabled) {
          setValidated(true);
        } else {
          setValidated(false);
        }
      } else {
        setValidated(true);
      }
    } else if (!seo) {
      if (searchEnabled || displayEnabled || socialEnabled || videoEnabled) {
        setValidated(true);
      } else setValidated(false);
    }
  });

  const subServices = [searchEnabled, displayEnabled, socialEnabled, videoEnabled].filter((el) => el === true);
  const [ppc, setPpc] = useState(subServices.length > 0 ? true : false);

  const setPpcHelper = () => {
    if (ppc === true) {
      setSearchEnabled(false);
      setDisplayEnabled(false);
      setSocialEnabled(false);
      setVideoEnabled(false);
    }
    setPpc(!ppc);
  };

  const services = [
    ["Search", searchEnabled, searchA, searchI, setSearchEnabled],
    ["Display", displayEnabled, displayA, displayI, setDisplayEnabled],
    ["Social", socialEnabled, socialA, socialI, setSocialEnabled],
    ["Video", videoEnabled, videoA, videoI, setVideoEnabled],
  ];

  // Need to complete pages in progress tracker that do not need to be set up
  const completePages = (pages) => {
    const submitUrl = "/datapulse/onboarding/complete_pages";
    let paramsObject = {
      client_account_id: client_account.id,
      pages: pages,
    };
    $.ajax({
      type: "POST",
      url: submitUrl,
      dataType: "json",
      async: true,
      contentType: "application/json",
      data: JSON.stringify(paramsObject),
      success: (data, success, xhr) => {
        console.log("Completed pages: " + JSON.stringify(pages));
      },
    });
  };
  const incompletePageFunc = (pages) => {
    const submitUrl = "/datapulse/onboarding/incomplete_pages";
    let paramsObject = {
      client_account_id: client_account.id,
      pages: pages,
    };
    $.ajax({
      type: "POST",
      url: submitUrl,
      dataType: "json",
      async: true,
      contentType: "application/json",
      data: JSON.stringify(paramsObject),
      success: (data, success, xhr) => {
        console.log("Incompleted pages: " + JSON.stringify(pages));
      },
    });
  };

  return (
    <Container fluid className="services">
      <Row className=" pb-3 justify-content-center">
        <Col style={{ maxWidth: "100%", textAlign: "center" }}>
          <p className="visby-bold f28 primary">What services will be provided?</p>
        </Col>
      </Row>

      <Row style={{ marginBottom: "70px" }} className="justify-content-center">
        <Col className="text-center">
          <Button
            onClick={() => {
              setPpcHelper();
            }}
            className={ppc ? "active-box ppc" : "choose-box ppc"}>
            <div>{ppc ? ppcA : ppcI}</div>
            <div>
              <p className="f24 pb-2 visby-bold primary">PPC</p>
            </div>
          </Button>

          <Button
            onClick={() => {
              setSeo(!seo);
            }}
            className={seo ? "seo-active" : "choose-box seo"}>
            <div>{seo ? seoA : seoI}</div>

            <div>
              <p className="f24 pb-2 visby-bold primary">SEO</p>
            </div>
          </Button>
        </Col>
      </Row>
      <div style={{ display: !ppc && "none" }}>
        <Row className="justify-content-center">
          <Col className="text-center">
            <p className="nunito-regular pb-2 f16 primary">Select PPC sub-services</p>
          </Col>
        </Row>
        <Row className="justify-content-center">
          <Col>
            <input hidden name="current_onboarding_page" value={window.location.href} readOnly />
            <div style={{ marginBottom: "70px" }} className="text-center ppc-subservices">
              {services.map((service, idx) => {
                return (
                  <Button
                    key={idx}
                    onClick={(e) => {
                      service[4](!service[1]);
                    }}
                    className={service[1] ? "active-box-small " : "choose-box-small"}>
                    {service[1] ? service[2] : service[3]}

                    <div>
                      <p className="f16 pb-2 visby-bold primary">{service[0]}</p>
                    </div>
                  </Button>
                );
              })}
            </div>
          </Col>
        </Row>
      </div>

      <Row className="justify-content-center">
        <Col>
          <div className="navButtonRow">
            <BackButton />
            <SkipButton btnText={`Skip for now`} nextPage={nextPage.url} />
            <NextButton
              validated={validated}
              btnText={`Next`}
              nextPage={nextPage.url}
              invalidText={`We need more information on this page before you continue.`}
              submitForm={submitForm}
              onClick={() => {
                // Some pages won't be necessary to fill out
                let pageNames = [];
                let incompletePageNames = [];
                if (!searchEnabled) {
                  pageNames.push("search_goals");
                } else {
                  incompletePageNames.push("search_goals");
                }
                if (!socialEnabled) {
                  pageNames.push("social_goals");
                  pageNames.push("social_conversions");
                } else {
                  incompletePageNames.push("social_goals");
                  incompletePageNames.push("social_conversions");
                }
                if (!displayEnabled) {
                  pageNames.push("display_goals");
                } else {
                  incompletePageNames.push("display_goals");
                }
                if (!videoEnabled) {
                  pageNames.push("video_goals");
                } else {
                  incompletePageNames.push("video_goals");
                }
                if (!searchEnabled && !displayEnabled && !videoEnabled) {
                  pageNames.push("scripts");
                } else {
                  incompletePageNames.push("scripts");
                }
                if (client_account.account_type === "leadgen") {
                  pageNames.push("inflation");
                  if (!searchEnabled && !socialEnabled && !displayEnabled && !videoEnabled) {
                    pageNames.push("ppc_service_agreements");
                    pageNames.push("ppc_configuration_intro");
                    pageNames.push("track_specific_action_ids");
                    pageNames.push("campaign_groups");
                    pageNames.push("ppc_data_pull");
                    pageNames.push("all_ppc_goals");
                    pageNames.push("ppc_dashboard_customization");
                    pageNames.push("ppc_dashboard_customization_all");
                    pageNames.push("ppc_alerts");
                    pageNames.push("datafeedwatch_install");
                  } else {
                    incompletePageNames.push("ppc_service_agreements");
                    incompletePageNames.push("ppc_configuration_intro");
                    incompletePageNames.push("track_specific_action_ids");
                    incompletePageNames.push("campaign_groups");
                    incompletePageNames.push("ppc_data_pull");
                    incompletePageNames.push("all_ppc_goals");
                    incompletePageNames.push("ppc_dashboard_customization_all");
                    incompletePageNames.push("ppc_alerts");
                    incompletePageNames.push("datafeedwatch_install");
                  }
                }
                if (client_account.account_type === "ecommerce") {
                  if (!searchEnabled && !socialEnabled && !displayEnabled && !videoEnabled) {
                    pageNames.push("ppc_service_agreements");
                    pageNames.push("ppc_configuration_intro");
                    pageNames.push("track_specific_action_ids");
                    pageNames.push("inflation");
                    pageNames.push("campaign_groups");
                    pageNames.push("ppc_data_pull");
                    pageNames.push("all_ppc_goals");
                    pageNames.push("ppc_dashboard_customization");
                    pageNames.push("ppc_dashboard_customization_all");
                    pageNames.push("ppc_alerts");
                    pageNames.push("datafeedwatch_install");
                  } else {
                    incompletePageNames.push("ppc_service_agreements");
                    incompletePageNames.push("ppc_configuration_intro");
                    incompletePageNames.push("track_specific_action_ids");
                    incompletePageNames.push("campaign_groups");
                    incompletePageNames.push("ppc_data_pull");
                    incompletePageNames.push("all_ppc_goals");
                    incompletePageNames.push("ppc_dashboard_customization");
                    incompletePageNames.push("ppc_dashboard_customization_all");
                    incompletePageNames.push("ppc_alerts");
                    incompletePageNames.push("datafeedwatch_install");
                    incompletePageNames.push("inflation");
                  }
                }
                if (!seo) {
                  pageNames.push("seo_service_agreements");
                  pageNames.push("seo_configuration_intro");
                  pageNames.push("keyword_groups");
                  pageNames.push("landing_pages");
                  pageNames.push("semrush_setup");
                  pageNames.push("google_analytics_goal_tracking");
                  pageNames.push("seo_data_pull");
                  pageNames.push("google_my_business_access");
                  pageNames.push("seo_goals");
                  pageNames.push("seo_dashboard_customization");
                  pageNames.push("seo_alerts");
                } else {
                  incompletePageNames.push("seo_service_agreements");
                  incompletePageNames.push("seo_configuration_intro");
                  incompletePageNames.push("keyword_groups");
                  incompletePageNames.push("landing_pages");
                  incompletePageNames.push("semrush_setup");
                  incompletePageNames.push("google_analytics_goal_tracking");
                  incompletePageNames.push("seo_data_pull");
                  incompletePageNames.push("seo_goals");
                  incompletePageNames.push("seo_dashboard_customization");
                  incompletePageNames.push("seo_alerts");
                }
                completePages(pageNames.map((page) => `/datapulse/onboarding/${page}`));
                incompletePageFunc(incompletePageNames.map((page) => `/datapulse/onboarding/${page}`));
              }}
            />
          </div>
        </Col>
      </Row>
    </Container>
  );
}
